'use strict';

var USER_STATUS = /*#__PURE__*/function (USER_STATUS) {
  USER_STATUS[USER_STATUS["DISABLED"] = 0] = "DISABLED";
  USER_STATUS[USER_STATUS["NORMAL"] = 1] = "NORMAL";
  USER_STATUS[USER_STATUS["SUSPICIOUS"] = 2] = "SUSPICIOUS";
  USER_STATUS[USER_STATUS["TRUSTY"] = 3] = "TRUSTY";
  return USER_STATUS;
}({});
exports.USER_STATUS = USER_STATUS;
